import * as React from 'react';
import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import get from 'lodash/get'
import { graphql, useStaticQuery } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import ResourceTiles from './ResourceTiles';
 
const MainWrap = styled.div`
  padding: 3rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  p {
    max-width: 50rem;
  }
`
 
const ThankYouPage = props => {
  const data = useStaticQuery(graphql`
    query {
      contentfulGlobal(title: {eq: "Thank You"}) {
        ...NodeGlobalFields
      }
    }
  `).contentfulGlobal;
  const title = get(data, "title");
  const copyJson = get(data, "richText1.json");
  return (
    <Container>
      <MainWrap>
        <h2>{title}</h2>
        {documentToReactComponents(copyJson)}
      </MainWrap>
      <ResourceTiles />
    </Container>
  )
}
 
export default ThankYouPage